export type { NumberOfApplicantsInfoStepDataType } from '../../../types'
import { BaseWizardContext, HierarchicalApplicationData, NumberOfApplicantsInfoStepDataType } from '../../../types'

export interface NumberOfApplicantsInfoStepContext extends NumberOfApplicantsInfoStepDataType, BaseWizardContext {}

export enum SecLoansAloneOrTogether {
  Alone = 'alone',
  Together = 'together',
}

export interface NumberOfApplicantsInfoFormData extends HierarchicalApplicationData {
  aloneOrTogether: SecLoansAloneOrTogether
}
